export const CHAT_FLOW = Object.freeze({
  HOME: "home",
  SEND_MONEY: "send_money",
});

export const CHAT_STEP = Object.freeze({
  IDLE: "idle",
  CHOOSING_RECIPIENT: "choosing_recipient",
  CREATING_RECIPIENT: "creating_recipient",
  ENTERING_AMOUNT: "entering_amount",
  GETTING_QUOTE: "getting_quote",
  CHOOSING_FUNDING: "choosing_funding",
  REVIEWING_DRAFT: "reviewing_draft",
  CREATING_TRANSFER: "creating_transfer",
  AWAITING_PIN: "awaiting_pin",
  CONFIRMING_TRANSFER: "confirming_transfer",
  AWAITING_BANK_FUNDING: "awaiting_bank_funding",
  AWAITING_CARD_FUNDING: "awaiting_card_funding",
  TRACKING_TRANSFER: "tracking_transfer",
});

export const CHAT_EFFECT = Object.freeze({
  NAVIGATE: "navigate",
  PREVIEW_QUOTE: "preview_quote",
  CREATE_TRANSFER: "create_transfer",
});

export const CHAT_INTENT = Object.freeze({
  SEND_MONEY: "send_money",
  RECIPIENTS: "recipients",
  ACTIVITY: "activity",
  RATES: "rates",
  PROFILE: "profile",
  SECURITY: "security",
  KYC: "kyc",
  SUPPORT: "support",
  NOTIFICATIONS: "notifications",
  HOME: "home",
  HELP: "help",
  BACK: "back",
  CANCEL: "cancel",
  UNKNOWN: "unknown",
});

export const CUSTOMER_ROUTES = Object.freeze({
  home: "/home",
  recipients: "/home",
  activity: "/transactionhistory",
  rates: "/fxcalculator",
  profile: "/profile/edit",
  security: "/pin/change",
  kyc: "/kyc",
  support: "/support",
  notifications: "/notifications",
});